import React from 'react';
import Card from "@material-ui/core/Card"
import {CardHeader, CardText} from '@material-ui/core/Card';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem/';
import ListItemIcon from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItem';
import InboxIcon from '@material-ui/icons';
import DraftsIcon from '@material-ui/icons';




export default class Home extends React.Component {

    render(){

        return (
          <b>BETA </b>
          
        );
    }
}



// WEBPACK FOOTER //
// ./src/Component/Home.js